import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ILoadingOptions } from '../models';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private totalRequests = 0;
  private readonly spinnerDelay = 500;
  loading$: Subject<ILoadingOptions> = new Subject();

  startLoading(loadingOptions: ILoadingOptions) {
    this.totalRequests++;
    setTimeout(() => {
      if (this.totalRequests > 0) {
        this.loading$.next(loadingOptions);
      }
    }, this.spinnerDelay);
  }

  stopLoading(loadingOptions: ILoadingOptions) {
    this.totalRequests--;
    if (this.totalRequests === 0) {
      this.loading$.next(loadingOptions);
    }
  }
}
